"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.set");

require("core-js/modules/web.dom.iterable");

var _toConsumableArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

require("core-js/modules/es6.function.name");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _vuexClass = require("vuex-class");

var _socket = require("socket.io-client");

var _elementUi = require("element-ui");

var _loading = require("@/mixins/loading/loading");

var _lastMileDeliveryWellcome = require("@/mixins/last-mile-delivery-wellcome/last-mile-delivery-wellcome");

var _permission = require("@/mixins/permission/permission");

var _idle = require("@/mixins/idle/idle");

var _orderDateRange = _interopRequireDefault(require("../components/order-date-range/order-date-range.vue"));

var _orderFilter = _interopRequireDefault(require("../components/order-filter/order-filter.vue"));

var _orderFilterTag = _interopRequireDefault(require("../components/order-filter-tag/order-filter-tag.vue"));

var _orderTable = _interopRequireDefault(require("../components/order-table/order-table.vue"));

var _ganttFilter = _interopRequireDefault(require("../components/gantt-filter/gantt-filter.vue"));

var _ganttPagination = _interopRequireDefault(require("../components/gantt-pagination/gantt-pagination.vue"));

var _ganttChart = _interopRequireDefault(require("../components/gantt-chart/gantt-chart.vue"));

var _planHeader = _interopRequireDefault(require("../components/plan-header/plan-header.vue"));

var _planSearch = _interopRequireDefault(require("../components/plan-search/plan-search.vue"));

var _orderSummary = _interopRequireDefault(require("../components/order-summary/order-summary.vue"));

var _truckSummary = _interopRequireDefault(require("../components/truck-summary/truck-summary.vue"));

var _variables = _interopRequireDefault(require("@/styles/mixins/_variables.scss"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LMDAutoAssignComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(LMDAutoAssignComponent, _Mixins);

  var _super = _createSuper(LMDAutoAssignComponent);

  function LMDAutoAssignComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, LMDAutoAssignComponent);
    _this = _super.apply(this, arguments);
    _this.isShowFailedOrders = false;
    _this.failedOrders = [];
    _this.isEnableAllTrucks = true;
    _this.selectedPlanId = null;
    _this.initAutoAddedDays = 0;
    _this.timeStepper = 30;
    _this.currentPlanId = null;
    _this.truckCurrentPage = 1;
    _this.truckPageSize = 10;
    _this.socket = null;
    _this.isBlocked = false;
    _this.manualAssignUsername = null;
    _this.isFilterTruck = false;
    _this.isShowEnabledTruck = false;
    _this.isUpdateBufferTrucks = {
      hasValue: false
    };
    return _this;
  }

  (0, _createClass2.default)(LMDAutoAssignComponent, [{
    key: "$isOrderFullscreen",
    get: function get() {
      return this.$store.getters['common/isOrderFullscreen'];
    }
  }, {
    key: "planHeaderStyle",
    get: function get() {
      return {
        top: !this.$isFullscreen ? '60px' : 0
      };
    }
  }, {
    key: "planBodyStyle",
    get: function get() {
      var height = '47px';

      if (this.$isFullscreen && !this.$isOrderFullscreen) {
        height = '44px';
      }

      if (this.$isFullscreen && this.$isOrderFullscreen) {
        height = '0';
      }

      return {
        'margin-top': height
      };
    }
  }, {
    key: "beforeRouteLeave",
    value: function beforeRouteLeave(to, from, next) {
      this.confirmUnsavedChanges(to, from, next);
    }
  }, {
    key: "created",
    value: function created() {
      if (window.innerWidth < _variables.default['md-min']) {
        this.$isMobile = true;
      }
    }
  }, {
    key: "mounted",
    value: function () {
      var _mounted = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _query;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.routes = [];
                _context.next = 3;
                return this.$setTableLoading(false);

              case 3:
                _context.next = 5;
                return this.$getOrderLocationLists({
                  locationType: this.$defaultLocationType,
                  startTime: this.$startDate,
                  endTime: this.$endDate
                });

              case 5:
                _context.next = 7;
                return this.$getTrucks();

              case 7:
                _context.next = 9;
                return this.$initPlan();

              case 9:
                this.disableInvalidTrucks();
                this.socket = (0, _socket.io)("".concat(process.env.VUE_APP_API_ROUTING_SOCKET, "/v1/lastmile/planning"), {
                  secure: true,
                  reconnection: true,
                  rejectUnauthorized: false,
                  query: (_query = {}, (0, _defineProperty2.default)(_query, process.env.VUE_APP_CUSTOMER_KEY, this.$userInformation.customerKey), (0, _defineProperty2.default)(_query, "routeName", this.$route.name), (0, _defineProperty2.default)(_query, "userEmail", this.$userInformation.user.name), _query),
                  extraHeaders: (0, _defineProperty2.default)({}, process.env.VUE_APP_SECRET_KEY, process.env.VUE_APP_SECRET_KEY_HASH)
                });
                this.updateSelectedData();

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function mounted() {
        return _mounted.apply(this, arguments);
      }

      return mounted;
    }()
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      this.routes = [];

      if (this.socket) {
        this.socket.close();
      }
    }
  }, {
    key: "handleAutoAssign",
    value: function () {
      var _handleAutoAssign = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        var orders, autoAssign, trucks, invalidOrderIds, selectedOrderIds, invalidRes, noSolutionFoundWithReason, message, failedOrders, _message, finalOrderIds, filteredOutTruckIds, plan, _message2;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.isAutoAssignLoading = true;
                orders = this.$selectedOrders.filter(function (order) {
                  return !_this2.isInvalidOrder(order);
                });
                _context2.next = 4;
                return this.autoAssign({
                  orders: orders,
                  startTime: this.$defaultTime
                });

              case 4:
                autoAssign = _context2.sent;
                trucks = [];
                invalidOrderIds = [];
                selectedOrderIds = [];
                invalidRes = (0, _toConsumableArray2.default)(autoAssign['invalid']);
                this.failedOrders = [];
                this.$failedOrders = [];
                noSolutionFoundWithReason = (this.helper.get(autoAssign, 'error', null) === 'no solution found' || this.helper.get(autoAssign, 'error', null) === 'no vehicle found') && autoAssign.invalid.length !== 0;

                if (autoAssign && invalidRes.length > 0 && autoAssign['vehicles'] && autoAssign['vehicles'].length || noSolutionFoundWithReason) {
                  message = {
                    title: this.$i18n.t('planning.messages.successInvalidRoutes'),
                    duration: 5000
                  };

                  if (!noSolutionFoundWithReason) {
                    _elementUi.Notification.success(message);
                  } // NOTE: fix grouping logic is on backend


                  failedOrders = invalidRes.map(function (irData) {
                    selectedOrderIds.push(irData['orderId']);
                    return {
                      code: irData['code'] || '',
                      type: irData['type'] || '',
                      reason: irData['reason'] || '',
                      orderId: irData['orderId'] || [],
                      shipmentReference: irData['shipmentReference'] || [],
                      plateNumber: irData['plateNumber'] || [],
                      vehicleId: irData['vehicleId'] || []
                    };
                  }); // invalidOrderIds = this.helper.flatten(failedOrders.map(i => i.orderId));

                  invalidOrderIds = (0, _toConsumableArray2.default)(autoAssign['invalidOrder']);
                  this.handleFailedOrders({
                    isShowFailedOrders: true,
                    failedOrders: failedOrders
                  });
                  this.$pagination = _objectSpread(_objectSpread({}, this.$pagination), {}, {
                    currentPage: 1
                  });
                }

                if (!(this.helper.get(autoAssign, 'error', null) === 'no solution found' || this.helper.get(autoAssign, 'error', null) === 'no vehicle found')) {
                  _context2.next = 18;
                  break;
                }

                _message = {
                  title: this.$i18n.t('planning.messages.noSolution'),
                  duration: 5000
                };

                _elementUi.Notification.error(_message);

                _context2.next = 36;
                break;

              case 18:
                if (!(autoAssign && autoAssign['vehicles'] && autoAssign['vehicles'].length)) {
                  _context2.next = 34;
                  break;
                }

                finalOrderIds = [];
                filteredOutTruckIds = [];
                autoAssign['vehicles'].forEach(function (vehicle) {
                  var truckObj = _this2.getTruckInPlan(vehicle.truckId);

                  if (vehicle.orderId && vehicle.orderId.length >= 1) {
                    if (vehicle.type === 'MANUALASSIGN' && !_this2.helper.isUndefined(truckObj)) {
                      finalOrderIds = _this2.helper.uniq([].concat((0, _toConsumableArray2.default)(finalOrderIds), (0, _toConsumableArray2.default)(vehicle.orderId), (0, _toConsumableArray2.default)(truckObj['orderId'])));
                    } else {
                      finalOrderIds = _this2.helper.uniq([].concat((0, _toConsumableArray2.default)(finalOrderIds), (0, _toConsumableArray2.default)(vehicle.orderId)));
                    }
                  }

                  if (vehicle.routes && vehicle.routes.length > 0) {
                    filteredOutTruckIds.push(vehicle.truckId);
                    var nOrderIds = [];
                    vehicle.routes.map(function (route) {
                      nOrderIds = [].concat((0, _toConsumableArray2.default)(nOrderIds), (0, _toConsumableArray2.default)(route['orderId']));
                      return route;
                    });
                    trucks.push(_objectSpread(_objectSpread({}, vehicle), {}, {
                      orderId: (0, _toConsumableArray2.default)(new Set(nOrderIds)),
                      locked: false
                    }));
                  }
                });

                if (trucks.length > 0) {
                  this.$anyChanges = true;
                }

                finalOrderIds = (0, _toConsumableArray2.default)(new Set(finalOrderIds));
                plan = this.helper.cloneDeep(this.$plan);
                plan['orders'] = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(plan['orders']), (0, _toConsumableArray2.default)(orders)).filter(function (o) {
                  return !invalidOrderIds.includes(o['id']);
                }), 'id');
                plan['trucks'] = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(plan['trucks'].filter(function (i) {
                  return !_this2.helper.includes(filteredOutTruckIds, i.truckId);
                })), trucks), 'truckId');
                this.$setPlan({
                  plan: plan
                });
                this.$selectedOrders = this.$selectedOrders.filter(function (i) {
                  return _this2.helper.includes(selectedOrderIds, i['id']);
                });
                this.$excludedOrders = this.helper.uniq((0, _toConsumableArray2.default)(this.$plan.orders.map(function (o) {
                  return o['id'];
                })).filter(function (id) {
                  return !invalidOrderIds.includes(id);
                }));
                _context2.next = 32;
                return this.$getUnassignedOrders();

              case 32:
                _context2.next = 36;
                break;

              case 34:
                _message2 = {
                  title: this.$i18n.t('planning.messages.noTrucks'),
                  duration: 5000
                };

                _elementUi.Notification.error(_message2);

              case 36:
                this.isAutoAssignLoading = false;

              case 37:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleAutoAssign() {
        return _handleAutoAssign.apply(this, arguments);
      }

      return handleAutoAssign;
    }()
  }, {
    key: "handleEnableAllTrucks",
    value: function handleEnableAllTrucks() {
      this.isEnableAllTrucks = true;
    }
  }, {
    key: "handleDisableAllTrucks",
    value: function handleDisableAllTrucks() {
      this.isEnableAllTrucks = false;
    }
  }, {
    key: "handleSearchValueIsFound",
    value: function handleSearchValueIsFound(newVal) {
      this.selectedPlanId = newVal;
    }
  }, {
    key: "recalculateTimeList",
    value: function recalculateTimeList(newVal) {
      this.initAutoAddedDays = newVal;
    }
  }, {
    key: "handleTimeStepperChanges",
    value: function handleTimeStepperChanges(newVal) {
      this.timeStepper = newVal;
    }
  }, {
    key: "handleCurrentPlanIdChanges",
    value: function handleCurrentPlanIdChanges(newVal) {
      this.currentPlanId = newVal;
    }
  }, {
    key: "handleFailedOrders",
    value: function handleFailedOrders(_ref) {
      var isShowFailedOrders = _ref.isShowFailedOrders,
          failedOrders = _ref.failedOrders;
      this.isShowFailedOrders = isShowFailedOrders;
      this.failedOrders = this.helper.orderBy(failedOrders.map(function (fOData) {
        fOData['finalCode'] = fOData['code'] || '';
        fOData['finalPriority'] = '';

        if (fOData['code']) {
          var codeArr = fOData['code'].toString().split('-');

          if (codeArr.length === 2) {
            fOData['finalPriority'] = codeArr[0] || '';
            fOData['finalCode'] = codeArr[1] || '';
          }
        }

        return fOData;
      }), ['finalPriority'], ['asc']);
      this.$failedOrders = failedOrders;
    }
  }, {
    key: "updateSelectedData",
    value: function updateSelectedData() {
      var _this3 = this;

      this.socket.on('connect', /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.logger.info('socket-connected', _this3.socket.id);

                _this3.$socketId = _this3.socket.id;
                _this3.isBlocked = false;
                _this3.isOccupied = false;

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
      this.socket.on('connected', /*#__PURE__*/function () {
        var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(res) {
          var userData;
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  userData = _this3.helper.get(res, 'data.userData', []);

                  if (userData && userData.length >= 1) {
                    userData = userData.filter(function (uData) {
                      return Number(uData.companyId) === Number(_this3.$userInformation.company.id);
                    });

                    if (userData[0] && userData[0]['routeName'] !== _this3.$route.name && userData[0]['userId'] !== _this3.$socketId) {
                      _this3.isBlocked = true;
                      _this3.manualAssignUsername = userData[0]['userName'].split('@')[0];
                      _this3.isOccupied = true;
                      _this3.occupyingUsername = userData[0]['userName'].split('@')[0];
                      _this3.occupyingRoute = userData[0]['routeName'];
                    } else {
                      _this3.isBlocked = false;
                      _this3.isOccupied = false;
                    }
                  } else {
                    _this3.isBlocked = false;
                    _this3.isOccupied = false;
                  }

                  _this3.logger.info('Socket - Connected', res);

                  if (res.data && res.status === 'success') {
                    _this3.$GLOBAL_ACTIVE_USERS = (0, _toConsumableArray2.default)(userData);
                    _this3.$GLOBAL_SELECTED_ORDERS = res.data.orderData.length >= 1 ? res.data.orderData.filter(function (oData) {
                      return oData['userId'] !== _this3.$socketId;
                    }) : [];
                    _this3.$GLOBAL_SELECTED_TRUCKS = res.data.truckData.length >= 1 ? res.data.truckData.filter(function (tData) {
                      return tData['userId'] !== _this3.$socketId;
                    }) : [];
                  }

                case 4:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }());
      this.socket.on('saved', function (res) {
        _this3.logger.info('Socket - Saved', res);

        if (res.status === 'success' && res.data && res.data.code === _this3.$planDate) {
          _this3.updatePlanFromSocket(res.data);
        }
      });
      this.socket.on('error', /*#__PURE__*/function () {
        var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(res) {
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _this3.logger.info('socket-error');

                case 1:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        return function (_x2) {
          return _ref4.apply(this, arguments);
        };
      }());
      this.socket.on('connect_error', /*#__PURE__*/function () {
        var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(res) {
          return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  _this3.logger.info('socket-connect_error');

                case 1:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }));

        return function (_x3) {
          return _ref5.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "getReasonFailMessage",
    value: function getReasonFailMessage(reason) {
      return this.$t("planning.autoAssignInvalidCodes.".concat(reason));
    }
  }, {
    key: "getReasonFailParam",
    value: function getReasonFailParam() {
      var reason = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var reasonArr = reason.split('~');
      return this.helper.get(reasonArr, '1', '-').trim();
    }
  }, {
    key: "handleTruckSizeChange",
    value: function handleTruckSizeChange(newVal) {
      this.truckPageSize = newVal;
    }
  }, {
    key: "handleTruckCurrentChange",
    value: function handleTruckCurrentChange(newVal) {
      this.truckCurrentPage = newVal;
    }
  }, {
    key: "handleIsFilterTruckChanges",
    value: function handleIsFilterTruckChanges(newVal) {
      this.isFilterTruck = newVal;
    }
  }, {
    key: "handleIsShowEnabledTruckChanges",
    value: function handleIsShowEnabledTruckChanges(newVal) {
      this.isShowEnabledTruck = newVal;
    }
  }, {
    key: "handleUpdateBufferTrucks",
    value: function handleUpdateBufferTrucks(newVal) {
      this.isUpdateBufferTrucks = newVal;
    }
  }]);
  return LMDAutoAssignComponent;
}((0, _vuePropertyDecorator.Mixins)(_permission.PermissionMixin, _loading.LoadingMixin, _lastMileDeliveryWellcome.LastMileDeliveryMixin, _idle.IdleMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('isFullscreen', {
  namespace: 'common'
})], LMDAutoAssignComponent.prototype, "$isFullscreen", void 0);
LMDAutoAssignComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LMDAutoAssignComponent',
  components: {
    'order-date-range': _orderDateRange.default,
    'order-filter': _orderFilter.default,
    'order-filter-tag': _orderFilterTag.default,
    'order-table': _orderTable.default,
    'gantt-filter': _ganttFilter.default,
    'gantt-pagination': _ganttPagination.default,
    'gantt-chart': _ganttChart.default,
    'plan-header': _planHeader.default,
    'plan-search': _planSearch.default,
    'order-summary': _orderSummary.default,
    'truck-summary': _truckSummary.default,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-dialog': _elementUi.Dialog
  }
})], LMDAutoAssignComponent);
var _default = LMDAutoAssignComponent;
exports.default = _default;